// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__OMqsj","productName":"Table_productName__wdFIl"};